<template>
	<div style="padding: 0px;">
		<el-form :inline="false" :model="syslocinfo" :rules="rules" ref="sysuserrule" label-width="120px" class="">
			<el-row>
				<el-col :span="12">
					<el-form-item label="名称" prop="name">
						<el-input clearable :disabled="!editok" v-model="syslocinfo.name" maxlength="30"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="所属组织" prop="org">
						<el-cascader style="width: 100%;" :disabled="!editok" v-model="userorgid" :options="allOrgTree" :props="orgtreePro"  clearable></el-cascader>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row >
				<el-col :span="12">
					<el-form-item label="类型" prop="typeid">
						<el-select style="width: 100%;" :disabled="!editok" v-model="syslocinfo.typeid" placeholder="请选择类型">
							<el-option v-for="item in loctypelist" :key="item.id" :label="item.name" :value="item.id"> </el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="排序" prop="idx">
						<el-input-number :disabled="!editok" v-model="syslocinfo.idx" :min="1" :max="9999" :precision="2" :step="0.1" ></el-input-number>
					</el-form-item>
				</el-col>
			</el-row>
		</el-form>
		<div style="text-align: center;">
			<el-button v-show="!editok" type="primary" @click="editok = true">修改</el-button>
			<el-button v-show="editok" plain @click="closeDlg">取消</el-button>
			<el-button v-show="editok" type="primary" @click="saveSysLoc">保存</el-button>
		</div>
		
	</div>
</template>

<script> 
	import { querySysLocTypes, addSysLocation, editSysLocation } from '/static/apiUrl.js'
	export default {
		name : 'LocDetail',
		data() {
			return {
				editok: false,
				disabled_cord: false,
				syslocinfo : {
					id: "",
					name: "",
					parentid : '',
					orgid: "",
					typeid: "",
					idx : 0
				},
				loctypelist : [],
				rules:{
					name: [
						{ required: true, message: '请输入名称', trigger: 'blur' }
					],
					orgid: [
						{ required: true, message: '请选择校区', trigger: 'blur' }
					],
					typeid: [
						{ required: true, message: '请选择类型', trigger: 'blur' }
					],
				},
				orgtreePro : {
					checkStrictly: true,
					value : "id",
					label : "name",
					children : "children"
				},
				userorgid : [],
			}
		},
		mounted() {
			
		},
		BeforeCreate(){
			
		},
		props: {
			selectedloc: {
				type: Object,
				required: false
			},
			allOrgTree : {
				type : Array,
				required: true
			},
			add : {
				type : Boolean,
				required : false,
				default : false,
			}
		},
		watch: {
			add : {
				immediate: true,
				handler(newVal) {
					if(newVal == true){
						this.editok = true
					}else{
						this.editok = false
					}
				}
			},
			allOrgTree : {
				immediate: true,
				handler(newVal) {
					console.log(newVal)
					this.initData()
				}
			},
			selectedloc: {
				immediate: true,
				handler(newVal) {
					if(newVal != null){
						this.syslocinfo.id = newVal.id
						this.syslocinfo.name = newVal.name
						this.syslocinfo.parentid = newVal.parentid
						this.syslocinfo.orgid = newVal.orgid
						this.userorgid = newVal.orgid
						this.syslocinfo.typeid = newVal.typeid
						this.syslocinfo.idx = newVal.idx
					}else{
						this.syslocinfo.id = ""
						this.syslocinfo.name = ""
						this.syslocinfo.parentid = ""
						this.syslocinfo.orgid = ""
						this.syslocinfo.typeid = ""
						this.syslocinfo.idx = 0
					}
				}
			},
		},
		methods: {
			initData(){
				this.loctypelist = []
				querySysLocTypes().then(res => {
					if(0 == res.code){
						this.loctypelist = res.datas
					}
				})
			},
			closeDlg() {
				this.editok = false
				if(this.add){
					this.$emit("needRefrash",false,false)
				}
			},
			saveSysLoc(){
				this.$refs["sysuserrule"].validate((valid) => {
					if (valid) {
						const isArr = Array.isArray(this.userorgid);
						if(isArr && this.userorgid.length > 0){
							this.syslocinfo.orgid = this.userorgid[this.userorgid.length-1]
						}else{
							this.syslocinfo.orgid = this.userorgid
						}
						
						if(this.syslocinfo.id != null && this.syslocinfo.id != ''){  //编辑
							editSysLocation(this.syslocinfo).then(res => {
								if(0 == res.code){
									this.$message({
										showClose: true,
										message: "添加成功",
										type: 'success'
									});
									this.$emit("needRefrash",true,false)
								}else{
									this.$message({
										showClose: true,
										message: res.message,
										type: 'error'
									});
								}
							})
						}else{ //新增
							addSysLocation(this.syslocinfo).then(res => {
								if(0 == res.code){
									this.$message({
										showClose: true,
										message: "修改成功",
										type: 'success'
									});
									this.$emit("needRefrash",true,false)
								}else{
									this.$message({
										showClose: true,
										message: res.message,
										type: 'error'
									});
								}
							})
						}
						
					} else {
						return false;
					}
				});
			},
		},
		beforeDestroy() {
			
		},
	}
</script>

<style scoped>
	
</style>